import type { ComponentType, HTMLAttributes } from 'react'
import React from 'react'

import type { Icon } from '@slite/icons'

export type BreadcrumbItemProps<TIconProps extends object = object> = (
  | { icon: Icon; iconProps?: never }
  | {
      icon: ComponentType<TIconProps>
      iconProps: TIconProps
    }
  | {
      icon?: never
      iconProps?: never
    }
) & {
  renderLabel: (
    props: Pick<HTMLAttributes<HTMLDivElement>, 'className' | 'style'>
  ) => React.ReactElement
}

export function BreadcrumbItem<TIconProps extends object>({
  icon: Icon,
  iconProps,
  renderLabel,
}: BreadcrumbItemProps<TIconProps>) {
  return (
    <>
      {Icon && (
        <Icon
          {...(iconProps as TIconProps)}
          className="flexbox-no-shrink shade-20"
          style={{ marginRight: 5 }}
          size={14}
        />
      )}
      {renderLabel({
        className:
          'no-wrap shade-10 shade-05-on-hover font-size-large ellipsis',
        style: { minWidth: 0, flex: '1 1 0', maxWidth: 'max-content' },
      })}
    </>
  )
}
